// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ccfce24d","810":"0ac2d9ab"}[chunkId] + ".chunk.js";
};